module.exports = __webpack_public_path__ + "img/Conversation-Quote-Icon-WG.faf4eb85.svg";